import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WpTokenService } from './wp-token.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class RedirectHomePageGuard  {

  constructor(
    private router: Router,
    private verifyWpTokenService: WpTokenService
  ) { }

  canActivate(): boolean {

    if (this.verifyWpTokenService.isLoginToken()) {
      this.router.navigateByUrl(environment.homePagePath);
      return false;
    } else {
      sessionStorage.clear();
      return true;
    }
  }
}
